<template>
  <q-dialog :visible="isVisible" :title="title" width="50%" :innerScroll="false" :showFooter="false" @cancel="onCancelImport" @close="onCancelImport">
    <div v-loading="loading" element-loading-text="数据加载中" element-loading-spinner="el-icon-loading" style="padding: 20px 0">
      <el-form :model="requestParam" :rules="rules" ref="requestParam" label-width="100px">
        <el-row>
          <el-col :span="24" align="left">
            <el-form-item label="附件:">
              <el-upload
                class="upload-demo"
                accept=".jpg,.jpeg,.png,.gif"
                ref="upload"
                multiple
                :limit="999"
                action=""
                :disabled="disabled"
                :http-request="httpRequest"
                :on-remove="handleRemove"
                :headers="headers"
                :file-list="fileList"
                :on-success="handleSuccess"
                :before-upload="beforeUpload"
              >
                <el-button slot="trigger" size="small" type="primary" @click="importFile">选取文件夹</el-button>
                <el-button
                  style="margin-left: 10px"
                  v-loading.fullscreen.lock="fjLoading"
                  element-loading-text="数据导入中"
                  element-loading-spinner="el-icon-loading"
                  element-loading-background="rgba(0, 0, 0, 0.8)"
                  size="small"
                  type="success"
                  @click="checkFormValid"
                  >上传
                </el-button>
                <div slot="tip" class="el-upload__tip">只能上传图片文件，可批量上传，仅支持上传到“旧”文件夹中！</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div style="text-align: center">
        <el-button @click="onCancelImport" size="medium">取 消</el-button>
      </div>
    </div>
  </q-dialog>
</template>

<script>
import moment from 'moment';
import { getToken } from '@/utils/auth';
import axios from '@/utils/axiosInstance';
export default {
  name: 'up',
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    spuId: [String, Number],
    processType: {
      type: Number,
      default: 3,
    },
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
    title() {
      return '批量上传';
    },
  },
  watch: {
  },
  data() {
    return {
      loading: false,
      requestParam: {},
      rules: {
        businessType: [{ required: true, message: '不能为空', trigger: 'change' }],
        uploadType: [{ required: true, message: '不能为空', trigger: 'change' }],
        nodeName: [{ required: true, message: '不能为空', trigger: 'change' }],
      },
      headers: {
        Authorization: getToken(),
      },
      fileList: [],
      fileListAll: [],
      fjLoading: false,
      errorType: false,
      disabled: false,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.upload.$children[0].$refs.input.webkitdirectory = true;
    });
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    onCancelImport() {
      this.isVisible = false;
      this.fileList = [];
      this.fileListAll = [];
    },

    importFile(event) {
      if (this.fileList.length) {
        this.$message.error(`一次仅上传一个${this.title}文件夹`);
        this.disabled = true;
        setTimeout(() => {
          this.disabled = false;
        }, 20);
        return;
      }
      this.errorType = false;
    },

    handleRemove(file, fileList) {
      if (this.errorType) {
        this.fileList = [];
        return;
      }
      this.fileList = fileList;
      console.log(file, fileList);
    },
    httpRequest(file) {},
    handleSuccess(res, file) {
      if (res.code === 200) {
        this.$message.success(res.message);
      } else {
        this.$message.error(res.message);
      }
      this.onCancel();
    },
    // 验证
    beforeUpload(file) {
      // console.log(file.webkitRelativePath);
      // console.log(this.fileList);
      let pattern = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase();
      if (pattern != 'db' && pattern != 'ds_store') {
        //排除隐藏.db系统文件
        this.fileListAll.push(file);
      }
      if (this.errorType) {
        this.fileList = [];
        return;
      }
      if (!this.errorType && pattern != 'db' && pattern != 'ds_store') {
        this.fileList.push(file);
      }
    },
    checkFormValid(file) {
      this.$refs['requestParam'].validate((valid) => {
        if (valid) {
          this.submitUpload(file);
        } else {
          this.$message.error('参数校验失败！');
        }
      });
    },
    submitUpload(file) {
      if (!this.fileList || this.fileList.length === 0) {
        this.$message.error('请先上传图片');
        return;
      }
      const form = new FormData();
      const _this = this;
      var secondaryFileName = [];
      this.fileList.forEach((v) => {
        form.append('files', v);
        console.log(v);
        if ((v.webkitRelativePath.match(new RegExp('/', 'g')) || []).length > 1 && !v.webkitRelativePath.includes('ds_store')) {
          secondaryFileName.push(v.webkitRelativePath.match(/\/(.*?)\//)[1].trim());
        }
      });
      if (!secondaryFileName.length && this.requestParam.uploadType != '图片') {
        this.$message.error('请确认文件夹上传规范是否正确！');
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: '图片上传中...',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.7)',
      });
      this.$q.newProduct
        .oldBatchUpload({ data: form })
        .then((res) => {
          if (res.code == 200 && res.data) {
            var timer = setInterval(function () {
              _this.$q.common
                .reportTaskInfo({ fragment: [res.data] })
                .then((res) => {
                  if (res.data.taskStatus == '执行完成') {
                    clearInterval(timer);
                    loading.close();
                    if (res.data.taskResult == '成功') {
                      _this.$message.success('上传成功');
                      _this.isVisible = false;
                      _this.$emit('complete');
                    } else {
                      _this.onCancelImport();
                      _this.$message.error(res.data.failReason);
                    }
                  }
                })
                .catch((err) => {
                  loading.close();
                  this.$message.error(err.message);
                });
            }, 5000);
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((_) => {
          loading.close();
        });
    },
  },
};
</script>

<style lang="stylus" scoped>
.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 25px
}

.right50 {
  margin-right: 50px;
}

.footer {
  margin: 15px 0 5px 0;
  text-align: center
}

 >>> .el-upload-list {
   max-height: 50vh
   overflow-y: auto
 }

.pathWidth >>>.el-input {
  width: 300px
}
</style>
